<template>
  <div class="actions_history">

    <TextTable
      :all_data = "all_data"
    />

  </div>
</template>

<script>

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'CommunicationManagementHistory',
  components: {
    TextTable
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      load: true,
      all_data: {}
    }
  },

  created () {
    this.get_actions_history()
  },

  methods: {
    link_sim(link){
      this.$router.push(link)
    },
    show_status(status_id){
      return this.status_list[status_id]
    },

    get_actions_history(){
      this.$http.simcard.getSimcardActionsHistory((response) => {
        this.all_data = response.data.data
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .actions_history{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    &--header{
      padding-top: 1vh;
      padding-left: 2vh;
      padding-right: 2vh;
      font-size: 14px;
    }
    .response_table{
      thead{
        flex: 0 1 0;
      }
      tbody{
        overflow-y: scroll;
        tr{
          transition: 0.2s;
          &:hover{
            background-color: #eee;
          }
          .imsi{
            cursor: pointer;
            color: #0082c6;
          }
        }
      }
      .link{
        width: 50px;
      }
    }
  }
  .time_sync_simcard{
    cursor: pointer;
  }

  .link_simcard {
    cursor: pointer;
  }
 </style>
